const errors = {
  'This X_API_KEY already exists in the Interop Database':
    'X-API-Key already exists, Please try again after generating a new one',
  UNKNOWN_ERROR: 'Oops.., Something went wrong!',
  NO_EMPTY_KEY_VALUE: 'key and value can not be empty.',
  UNAUTHORIZED_USER: 'The user is not having access to this portal, Please, contact Alivecor Interop Owner to provide you access'
}

export default errors
